import { type TemplateResult } from 'lit';

export class LabeledListItem<T = string | string[] | TemplateResult> {
    constructor(
        public readonly label: string,
        public readonly value: T,
        public readonly clickEventName?: string
    ) {}
}
